import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Auth } from 'aws-amplify'
import { Elements, StripeProvider } from 'react-stripe-elements'
// import { Elements, StripeProvider } from '@stripe/react-stripe-js'
import { CSSTransition } from 'react-css-transition'
import { createBooking } from '../actions/bookingActions'
import StripePaymentForm from '../components/StripePaymentForm'
import BookingBreadcrumb from '../components/BookingBreadcrumb'
import Cart from '../components/BookingCart'
import Modal from '../components/Modal'
import FormattedCheckbox from '../components/FormattedCheckbox'
import TransitionStyles from '../lib/transitionStyles'
import BookingLib from '../lib/booking'
import { attempt } from '../lib/utils'
import ErrorBookingsCapacity from '../components/ErrorBookingsCapacity'

class BookingPaymentPage extends Component {
  
  constructor(props) {
    super(props)
    this.state = {
      booking: props.booking,
      // skus: [],
      currentModal: null,
      showValidationError: false,
      atUserBookingsCapacity: false,
      overrideHours: []
    }
    // this.updateBooking = this.updateBooking.bind(this)
    // this.onChange    = this.onChange.bind(this)
    this.onPaymentCompleted = this.onPaymentCompleted.bind(this)
    this.openTermsModal = this.openTermsModal.bind(this)
    this.onChangeByName = this.onChangeByName.bind(this)
    this.isValid = this.isValid.bind(this)
  }

  async componentWillMount() {
    window.scrollTo(0, 0); // TODO avoid duplication on all pages

    // const skus = await BookingLib.fetchSkus()
    // this.setState({skus: skus.data})
  }
  
  componentDidMount() {
    this.setCapacityState()
    this.setOverrideHours()
    this.setEmailState()
  }

  onChangeByName(name, value) {
    const { props } = this
    const { booking } = this.state
    booking[name] = value
    props.createBooking(booking)
  }

  onPaymentCompleted() {
    const {props} = this
    const { booking } = this.state
    booking.completed = true
    props.createBooking(booking)
    props.history.push('/bookings/completed')
  }

  async setEmailState() {
    const user = await Auth.currentAuthenticatedUser()
    const email = attempt(() => user.attributes.email)
    this.setState({ email })
  }

  async setCapacityState() {
    const atUserBookingsCapacity = await BookingLib.atUserBookingsCapacity()
    this.setState({ atUserBookingsCapacity });
  }

  async setOverrideHours() {
    const overrideHours = await BookingLib.getOverrides()
    this.setState({ overrideHours })
  }

  openTermsModal(url) {
    const closeModal = () => this.setState(prevState => ({ ...prevState, currentModal: null }))

    

    this.setState({
      currentModal: (
        <Modal size='lg' closeAction={closeModal}>
          <iframe
            src={url}
            style={{height: 'calc(100vh - 180px)'}}
            title='Vilkår og betingelser'
          />
        </Modal>
      )
    })
  }

  isValid() {
    const { booking } = this.state
    return booking.acceptBookingTerms
  }

  render() {
    const { skus } = this.props
    const { overrideHours, email } = this.state
    
    const { booking, currentModal, showValidationError, atUserBookingsCapacity } = this.state
    
    let step = booking.loggedInAtBeginning ? 4 : 5
    if (booking.invitation) {
      // TODO: Move to breadcrumb component
      step -= 1
    }

    return (
      <>
        {currentModal}
        <BookingBreadcrumb booking={booking} step={step} />


        <CSSTransition {...TransitionStyles} transitionAppear active>
          <div className="container mx-auto">
            <div className="lg:w-2/3 xl:w-3/5 mt-10 mb-12 mx-auto">
              <h4 className="text-harbor-80 uppercase text-sky">
                <FormattedMessage
                  id="booking.payment.category"
                  defaultMessage="New booking"
                />
              </h4>

              <h1 className="border-b pb-6 mb-8">
                <FormattedMessage id="booking.payment.header" defaultMessage="Payment" />
              </h1>

              <p>
                <FormattedMessage
                  id="booking.payment.description"
                  defaultMessage="You are now ready to complete your purchase and start looking forward to your ski trip."
                />
              </p>
              <p className="flex bg-grey-lighter p-4">
                <button
                  onClick={() => this.onChangeByName('acceptBookingTerms', !booking.acceptBookingTerms)}
                  className="flex items-center focus:outline-none"
                  type="button"
                >
                  <FormattedCheckbox
                    checked={booking.acceptBookingTerms}
                    className={`${showValidationError && !booking.acceptBookingTerms && 'border-red'}`}
                  />
                </button>
                
                <FormattedMessage id="booking.payment.accept.label" defaultMessage="I accept" />
                &nbsp;
                <button
                  onClick={() => this.openTermsModal('https://www.copenhill.dk/policies/vilkar-og-betingelser')}
                  className="text-grass underline font-bold"
                  type="button"
                >
                  <FormattedMessage id="booking.payment.accept.link" defaultMessage="terms and conditions" />
                </button>
              </p>
              
              <div className="mt-8">
                {/* eslint-disable-next-line no-undef */}
                <StripeProvider apiKey={process.env.REACT_APP_STRIPE_KEY}>
                  <Elements locale={window.bookingLocale}>
                    <StripePaymentForm
                      booking={booking}
                      skus={skus}
                      overrideHours={overrideHours}
                      onPaymentCompleted={this.onPaymentCompleted}
                      isValid={this.isValid}
                      atUserBookingsCapacity={atUserBookingsCapacity}
                    />
                  </Elements>
                </StripeProvider>
              </div>

              {atUserBookingsCapacity ? (
                <div className="mt-4">
                  <ErrorBookingsCapacity />
                </div>
              ) : <div className="mt-16" />}

              {skus.length > 0 && (
                <div className="mb-12">
                  <Cart skus={skus} overrideHours={overrideHours} openTermsModal={this.openTermsModal} email={email} />
                </div>
              )}
            </div>
          </div>
        </CSSTransition>

      </>
    )
  }
}

BookingPaymentPage.propTypes = {
  // booking: PropTypes.object,
  booking: PropTypes.shape({ booking: PropTypes.object }),
  skus: PropTypes.arrayOf(PropTypes.object)
}

BookingPaymentPage.defaultProps = {
  booking: {},
  skus: []
}

const mapStateToProps = state => ({
  booking: state.booking
})

export default connect(mapStateToProps, { createBooking })(BookingPaymentPage)
